/* Gimbel 2026-10-09: Recommended Add-Ons variant chooser (product pages).
   The add-on checkboxes rendered by snippets/product-form.liquid ('recommendend_addons' block) always
   carry the add-on product's FIRST variant id. For add-ons that have more than one variant, checking the
   box now opens the existing quick-add variant popup (window.gaVariantPicker in assets/custom.js) so the
   shopper picks the option. The chosen variant id is written to the checkbox value, which is what both
   add-to-cart submit handlers (custom.js and theme.js) already read. Nothing is added to the cart until
   the shopper presses the page's own Add to Cart button.
   Single-variant add-ons are untouched. If the popup or the product lookup is unavailable, the checkbox
   keeps its original first-variant behavior.
   Loaded from snippets/js-variables.liquid on product pages only. */
(function () {
  'use strict';
  if (window.__gaAddonVariantPicker) return;
  window.__gaAddonVariantPicker = true;

  var BOX_SEL = '.recommendend_addons input[type="checkbox"]';
  var CONFIRM_LABEL = 'Select Option';
  var DEFAULT_LABEL = 'Add to Cart';
  var cache = {};
  var state = null;
  var observed = null;

  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function handleFor(cb) {
    var item = cb.closest ? cb.closest('.addon-pro-item') : cb.parentNode;
    var a = item ? item.querySelector('a[href*="/products/"]') : null;
    if (!a) return null;
    var m = (a.getAttribute('href') || '').match(/\/products\/([^?#\/]+)/);
    if (!m) return null;
    try {
      return decodeURIComponent(m[1]);
    } catch (e) {
      return m[1];
    }
  }

  function load(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) {
          if (!r.ok) throw new Error('addon product fetch');
          return r.json();
        })
        .catch(function (err) {
          delete cache[handle];
          throw err;
        });
    }
    return cache[handle];
  }

  function injectStyles() {
    if (document.getElementById('ga-addon-vp-styles')) return;
    var css = document.createElement('style');
    css.id = 'ga-addon-vp-styles';
    css.textContent = [
      '.ga-addon-choice{display:block;margin-top:3px;color:#182b4b}',
      '.ga-addon-choice strong{font-weight:600}',
      '.ga-addon-change{background:none;border:0;padding:0;margin:0 0 0 6px;color:#01ccff;text-decoration:underline;cursor:pointer;font:inherit;line-height:inherit;-webkit-appearance:none;appearance:none}'
    ].join('');
    document.head.appendChild(css);
  }

  function overlayEl() {
    return document.querySelector('.ga-vm-overlay');
  }

  function setButtonLabel(text) {
    var ov = overlayEl();
    var btn = ov ? ov.querySelector('.ga-vm-add') : null;
    if (btn) btn.textContent = text;
  }

  function watchOverlay() {
    var ov = overlayEl();
    if (!ov || observed === ov || !window.MutationObserver) return;
    observed = ov;
    new MutationObserver(function () {
      if (state && !ov.classList.contains('is-open')) cancel();
    }).observe(ov, { attributes: true, attributeFilter: ['class'] });
  }

  function preselect(vid) {
    var tries = 0;
    (function tick() {
      if (!state) return;
      var ov = overlayEl();
      var btn = ov ? ov.querySelector('.ga-vm-variant[data-vid="' + vid + '"]') : null;
      if (btn) {
        if (!btn.disabled) btn.click();
        return;
      }
      if (++tries < 40) setTimeout(tick, 100);
    })();
  }

  function openFor(cb, handle, product) {
    if (!window.gaVariantPicker || typeof window.gaVariantPicker.open !== 'function') return;
    state = { cb: cb, handle: handle, product: product };
    window.gaVariantPicker.open(handle);
    setButtonLabel(CONFIRM_LABEL);
    watchOverlay();
    var prior = cb.getAttribute('data-ga-addon-chosen');
    if (prior) preselect(prior);
  }

  function cancel() {
    var s = state;
    state = null;
    setButtonLabel(DEFAULT_LABEL);
    if (s && s.cb && !s.cb.getAttribute('data-ga-addon-chosen')) s.cb.checked = false;
  }

  function showChoice(cb, variant) {
    var item = cb.closest ? cb.closest('.addon-pro-item') : cb.parentNode;
    if (!item) return;
    injectStyles();
    var line = item.querySelector('.ga-addon-choice');
    if (!line) {
      line = document.createElement('span');
      line.className = 'ga-addon-choice';
      item.appendChild(line);
    }
    line.textContent = '';
    line.appendChild(document.createTextNode('Option: '));
    var strong = document.createElement('strong');
    strong.textContent = variant.title;
    line.appendChild(strong);
    var change = document.createElement('button');
    change.type = 'button';
    change.className = 'ga-addon-change';
    change.textContent = 'Change';
    line.appendChild(change);

    var priceEl = null;
    Array.prototype.forEach.call(item.children, function (c) {
      if (!priceEl && c.tagName === 'SPAN' && !c.classList.contains('ga-addon-choice')) priceEl = c;
    });
    if (priceEl) priceEl.textContent = '(+' + money(variant.price) + ')';
  }

  function confirmSelection() {
    var s = state;
    var ov = overlayEl();
    var sel = ov ? ov.querySelector('.ga-vm-variant.is-selected') : null;
    var vid = sel ? sel.getAttribute('data-vid') : null;
    if (!s || !vid) return;
    var variant = null;
    (s.product.variants || []).forEach(function (v) {
      if (String(v.id) === String(vid)) variant = v;
    });
    if (!variant || !variant.available) return;
    s.cb.value = String(variant.id);
    s.cb.setAttribute('data-ga-addon-chosen', String(variant.id));
    s.cb.checked = true;
    showChoice(s.cb, variant);
    state = null;
    setButtonLabel(DEFAULT_LABEL);
    window.gaVariantPicker.close();
  }

  function onChecked(cb) {
    /* Already chose an option for this add-on: re-checking keeps it. "Change" reopens the popup. */
    if (cb.getAttribute('data-ga-addon-chosen')) return;
    var handle = handleFor(cb);
    if (!handle) return;
    load(handle)
      .then(function (product) {
        if (!cb.checked || state) return;
        if (!product || !product.variants || product.variants.length < 2) return;
        openFor(cb, handle, product);
      })
      .catch(function () {});
  }

  document.addEventListener('change', function (e) {
    var cb = e.target;
    if (!cb || !cb.matches || !cb.matches(BOX_SEL)) return;
    if (cb.checked) onChecked(cb);
  });

  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      if (state && t.closest('.ga-vm-add')) {
        e.preventDefault();
        e.stopImmediatePropagation();
        confirmSelection();
        return;
      }

      var change = t.closest('.ga-addon-change');
      if (change) {
        e.preventDefault();
        var item = change.closest('.addon-pro-item');
        var cb = item ? item.querySelector('input[type="checkbox"]') : null;
        var handle = cb ? handleFor(cb) : null;
        if (!cb || !handle) return;
        load(handle)
          .then(function (product) {
            if (!state) openFor(cb, handle, product);
          })
          .catch(function () {});
      }
    },
    true
  );

  function prefetch() {
    var seen = {};
    Array.prototype.forEach.call(document.querySelectorAll(BOX_SEL), function (cb) {
      var h = handleFor(cb);
      if (h && !seen[h]) {
        seen[h] = true;
        load(h).catch(function () {});
      }
    });
  }

  function start() {
    if (window.requestIdleCallback) window.requestIdleCallback(prefetch, { timeout: 3000 });
    else setTimeout(prefetch, 1200);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
